import { render, staticRenderFns } from "./Adviser.vue?vue&type=template&id=fb312b04&scoped=true"
import script from "./Adviser.vue?vue&type=script&lang=js"
export * from "./Adviser.vue?vue&type=script&lang=js"
import style0 from "./Adviser.vue?vue&type=style&index=0&id=fb312b04&prod&scoped=scoped&lang=less"
import style1 from "./Adviser.vue?vue&type=style&index=1&id=fb312b04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb312b04",
  null
  
)

export default component.exports